import DocumentTemplateListBlock from 'components/_dashboardPagesFeatures/documentTemplate/DocumentTemplateListBlock';
import LoaderComponent from 'components/ui/loadingIndicators/LoaderComponent';
import { MODEL_PERMISSION } from 'configs/permissions/modelPermissions';
import useInitializePage from 'hooks/useInitializePage';
import useLocales from 'hooks/useLocales';
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { PATH_PARAM_DASHBOARD, PATH_PARAM_TOKEN } from 'services/routing/PATH_PARAM';
import { RoutingServiceDashboard } from 'services/routing/RoutingService';
import { useSelector } from 'storage';
import useCurrentTabs from '../useModelsDirectoryTabs';

function EnterpriseDocumentTemplateListPage() {
  const { enterprise } = useSelector((state) => state.enterprise);
  const pathParams = useParams<typeof PATH_PARAM_TOKEN.modelsDirectory>();
  const { permissions } = useSelector((state) => state.auth);
  const { documentTemplateList, isLoading, pagination } = useSelector((state) => state.documentTemplate);
  const { enterpriseIsLoading } = useSelector((state) => state.enterprise);
  const { translate } = useLocales();
  const navigate = useNavigate();
  const tabs = useCurrentTabs();
  const isPageInitialized = useInitializePage(() => {
    const menu: MenuIconItemData[] = [];
    if (permissions.can(MODEL_PERMISSION.CAN_CREATE_DOCUMENT_TEMPLATE)) {
      menu.push({
        title: translate('pages.enterpriseDocumentTemplateAdd.title'),
        handler: () => navigate(RoutingServiceDashboard.modelsDirectory.documentTemplate.getAddPath(pathParams)),
        icon: 'add',
      });
    }
    const title = enterprise?.name || '';
    const breadcrumbs = RoutingServiceDashboard.modelsDirectory.documentTemplate.getListBc(pathParams, permissions, translate);
    return { menu, title, breadcrumbs, tabs, currentTab: PATH_PARAM_DASHBOARD.modelsDirectory.documentTemplates };
  }, [enterpriseIsLoading, isLoading]);

  const content = <DocumentTemplateListBlock isLoading={isLoading} documentTemplateList={documentTemplateList} pagination={pagination} />;

  return <>{!isPageInitialized ? <LoaderComponent /> : content}</>;
}

export default React.memo(EnterpriseDocumentTemplateListPage, () => true);
